import { Button, TextField } from "@mui/material";
import { Helmet } from "react-helmet-async";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { loginSuccessAction, loginWithGoogleAction } from "redux/actions/authActions";
import "./login.scss";
import { auth } from "firebaseConfig";
import { GoogleAuthProvider } from "firebase/auth";
import { signInWithPopup } from "firebase/auth";
import { AuthService } from "services/authService";
import { FcGoogle } from "react-icons/fc";
import { FaWhatsapp } from "react-icons/fa";
import { useEffect, useState } from "react";
import { getAuthUser } from "redux/selectors/getUser";

const Login = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const user = useSelector(getAuthUser);

  const [phone, setPhone] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (user) {
      navigate("/admin/inbox");
    }
  }, [user]);

  const signWithPhone = async (e) => {
    e.preventDefault();
    setError(null);
    setLoading(true);
    try {
      const { data } = await AuthService.loginWithPhone(phone.trim(), password);

      const members = data?.user?.members;
      if (members && members.length > 0) {
        let orgID = members[0].orgID;
        if (localStorage.getItem("orgID")) {
          orgID = localStorage.getItem("orgID");
        }
        localStorage.setItem("orgID", orgID);
      }

      dispatch(
        loginSuccessAction({
          user: data.user,
          token: data.token,
        })
      );
    } catch (ex) {
      console.error("signWithPhone ex: ", ex);
      setError(
        ex?.response?.data?.message ||
          "Не удалось войти. Проверьте телефон и пароль"
      );
    } finally {
      setLoading(false);
    }
  };

  const signWithGoogle = async () => {
    try {
      const provider = new GoogleAuthProvider();
      const firebaseAuthResponse = await signInWithPopup(auth, provider);
      console.log("firebaseAuthResponse:", firebaseAuthResponse);

      const firebaseUser = firebaseAuthResponse.user;

      const user = {
        email: firebaseUser.email,
      };

      const { data: responseUser } = await AuthService.signInWithGoogle(
        user,
        firebaseUser.accessToken
      );
      console.log("signWithGoogle: ", responseUser);


      if (responseUser.user?.members) {
        const members = responseUser?.user?.members
        if (members && members.length > 0) {
          let orgID = members[0].orgID
          if (localStorage.getItem('orgID')) {
            orgID = localStorage.getItem('orgID')
          }
          localStorage.setItem('orgID', orgID)
        }
      }      

      dispatch(
        loginWithGoogleAction({
          user: responseUser.user,
          token: responseUser.token,
        })
      );
    } catch (ex) {
      console.error("signWithGoogle ex: ", ex);
    }
  };

  return (
    <>
      <Helmet>
        <title>HajjTravel | Сайтқа тіркелу</title>
        <meta name="description" content="Школа программирования в Казахстане" />
      </Helmet>
      <div className="login container login-form-wrapper content">
        <div className="firebase-sign-in">
          <form onSubmit={signWithPhone} className="m-b-20 w-100">
            <div className="m-b-12">
              <TextField
                className="w-100"
                label="Номер телефона"
                placeholder="77472001991"
                value={phone}
                onChange={(e) => setPhone(e.target.value)}
                type="text"
                autoComplete="username"
                required
              />
            </div>
            <div className="m-b-12">
              <TextField
                className="w-100"
                label="Пароль"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                type="password"
                autoComplete="current-password"
                required
              />
            </div>
            {error && (
              <div style={{ color: "red", marginBottom: 12 }}>{error}</div>
            )}
            <Button
              type="submit"
              variant="contained"
              className="w-100"
              disabled={loading}
              style={{ padding: "8px 0" }}
            >
              {loading ? "Вход..." : "Войти"}
            </Button>
          </form>

          <div
            style={{ textAlign: "center", margin: "8px 0 16px", color: "#999" }}
          >
            или
          </div>

          <div className="m-b-20 w-100">
            <Link to={`/auth/whatsapp/signin`}>
              <Button className="w-100" style={{ backgroundColor: '#25d366', color: 'white', padding: '8px 0' }}>
                <FaWhatsapp size={20} className="m-r-8"></FaWhatsapp>
                Войти через Whatsapp</Button>
            </Link>
          </div>
          <button type="button" onClick={signWithGoogle}>
            <FcGoogle size={20} />
            Войти через Google
          </button>
        </div>
      </div>
    </>
  );
};

export default Login;
